export default function Alerts() {
    return (
        <ul>{Array.from(Array(1000), (e, i) => {
            return <li key={i}>{i * 2}</li>
        })}</ul>
    );
}